import React from 'react';

interface LoginButtonProps {
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

/**
 * ProSpliceWEB標準のシンプルなログインボタン
 * 既存の01_app_splicewebデザインに準拠
 */
const LoginButton: React.FC<LoginButtonProps> = ({
  onClick,
  className = '',
  children = 'ログイン'
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button 
      className={`nav-link ${className}`}
      onClick={handleClick}
      data-bs-toggle="modal" 
      data-bs-target="#loginModal"
      type="button"
    >
      <i className="fas fa-sign-in-alt me-2"></i>
      {children}
    </button>
  );
};

export default LoginButton; 